import React from 'react'
import SideBar from '../../components/commoncomponents/SideBar'
import Header from '../../components/commoncomponents/Header'
import Footer from '../../components/commoncomponents/Footer'
import { Layout, Content, ContentBody } from '../../assets/styled-components/layout'
import CreateAssetTypeCode from '../../components/assettypecodecomponents/CreateAssetTypeCode'

function AssetTypeCodeRegister({renderPageContent}) {
    return (
        <>
            
                        {/*Dynamic content goes here */}
                        <CreateAssetTypeCode renderPageContent={renderPageContent}/>
                 

        </>
    )
}

export default AssetTypeCodeRegister;